import { useMarkAsReadMutation } from '@/store/query/notification';
import { Button } from '@chakra-ui/react';

export const JoinInterviewButton = ({ meetingUrl, notification, ...props }) => {
  const [markAsRead] = useMarkAsReadMutation();

  const handleJoinInterview = () => {
    markAsRead({ id: notification?.id });
    window.open(meetingUrl, '_blank');
  };

  return (
    <Button
      variant="secondary"
      flex="1"
      onClick={handleJoinInterview}
      {...props}
    >
      Join interview
    </Button>
  );
};
